import { render, staticRenderFns } from "./SelectorExpediente.vue?vue&type=template&id=f9abc994"
import script from "./SelectorExpediente.vue?vue&type=script&lang=js"
export * from "./SelectorExpediente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports